import React from 'react';

// Style for truncating text in table cells
const truncateStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px'
};

// Format status display
const getStatusBadge = (status) => {
  const statusMap = {
    'New': {
      color: '#FFFFFF',
      backgroundColor: '#FFC107',
    },
    'Active': {
      color: '#FFFFFF',
      backgroundColor: '#00C853',
    },
    'Archived': {
      color: '#FFFFFF',
      backgroundColor: '#8B5CF6',
    }
  };

  const style = statusMap[status] || statusMap['New'];

  return (
    <span className="d-inline-block"
      style={{
        minWidth: '70px',
        textAlign: 'center',
        borderRadius: '20px',
        padding: '4px 8px',
        backgroundColor: style.backgroundColor,
        color: style.color,
        fontSize: '10px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      {status}
    </span>
  );
};

// Table columns configuration
export const tableColumns = [
  {
    name: 'Chapter ID',
    selector: row => row.chapter_id,
    sortable: true,
    center: true,
    width: '120px',
    style: truncateStyle,
  },
  {
    name: 'Course Name',
    selector: row => row.course_name,
    sortable: true,
    center: true,
    width: '160px',
    style: truncateStyle,
    cell: row => (
      <div style={{ 
        ...truncateStyle,
        color: '#5C61F2', 
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold'
      }}>
        {row.course_name}
      </div>
    ),
  },
  {
    name: 'Chapter Number',
    selector: row => row.sequence_number,
    sortable: true,
    center: true,
    width: '150px',
    style: truncateStyle,
  },
  {
    name: 'Chapter Title',
    selector: row => row.title,
    sortable: true,
    center: true,
    width: '210px',
    cell: row => (
      <div style={{ 
        ...truncateStyle,
        width: '100%',
        textAlign: 'center'
      }}>
        {row.title}
      </div>
    ),
  },
  {
    name: 'Created Date',
    selector: row => row.created_date,
    sortable: true,
    center: true,
    width: '150px',
    style: truncateStyle,
  },
  {
    name: 'Status',
    selector: row => row.status_component,
    sortable: true,
    center: true,
    width: '100px',
    style: truncateStyle,
  },
  {
    name: 'Action',
    selector: row => row.action,
    sortable: false,
    center: true,
    width: '210px',
    style: truncateStyle,
  }
];

export default tableColumns;